(function () {
  'use strict';

  function getSlideStride(track, slider) {
    var slide = track.querySelector('[data-npp-a-slider-slide]');

    if (!slide) {
      return track.clientWidth;
    }

    if (slider.hasAttribute('data-fcpdp-slider-desktop')) {
      var style = window.getComputedStyle(slide);
      var marginRight = parseFloat(style.marginRight) || 0;
      return slide.offsetWidth + marginRight;
    }

    return track.clientWidth;
  }

  function getActiveIndex(track, slider) {
    var stride = getSlideStride(track, slider);

    if (!stride) {
      return 0;
    }

    return Math.round(track.scrollLeft / stride);
  }

  function updateNavState(slider, track, slides, dots, prevBtn, nextBtn, index) {
    if (dots.length) {
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    var isAtStart = index <= 0 || track.scrollLeft <= 5;
    var isAtEnd =
      index >= slides.length - 1 ||
      track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;

    if (prevBtn) {
      prevBtn.disabled = isAtStart;
      prevBtn.classList.toggle('is-disabled', isAtStart);
    }

    if (nextBtn) {
      nextBtn.disabled = isAtEnd;
      nextBtn.classList.toggle('is-disabled', isAtEnd);
    }
  }

  function scrollToSlide(slider, track, slides, dots, prevBtn, nextBtn, index) {
    var targetSlide = slides[index];

    if (targetSlide) {
      track.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth'
      });
      updateNavState(slider, track, slides, dots, prevBtn, nextBtn, index);
    }
  }

  function initNppSlider(slider) {
    if (slider.dataset.nppASliderReady === 'true') {
      return;
    }

    slider.dataset.nppASliderReady = 'true';

    var track = slider.querySelector('[data-npp-a-slider-track]');
    var slides = slider.querySelectorAll('[data-npp-a-slider-slide]');
    var dots = slider.querySelectorAll('[data-npp-a-slider-dot]');
    var prevBtn = slider.querySelector('[data-npp-prev]');
    var nextBtn = slider.querySelector('[data-npp-next]');

    if (!track || !slides.length) {
      return;
    }

    var scrollTimer;

    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);

      scrollTimer = window.setTimeout(function () {
        var activeIndex = getActiveIndex(track, slider);
        updateNavState(slider, track, slides, dots, prevBtn, nextBtn, activeIndex);
      }, 80);
    });

    // Dot Navigation
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.slideIndex);
        scrollToSlide(slider, track, slides, dots, prevBtn, nextBtn, index);
      });
    });

    // Previous Button
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var currentIndex = getActiveIndex(track, slider);
        var index = Math.max(0, currentIndex - 1);
        scrollToSlide(slider, track, slides, dots, prevBtn, nextBtn, index);
      });
    }

    // Next Button
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var currentIndex = getActiveIndex(track, slider);
        var index = Math.min(slides.length - 1, currentIndex + 1);
        scrollToSlide(slider, track, slides, dots, prevBtn, nextBtn, index);
      });
    }

    updateNavState(slider, track, slides, dots, prevBtn, nextBtn, 0);
  }

  function initFeaturedCollectionPdp() {
    document
      .querySelectorAll('[data-fcpdp-section] [data-npp-a-slider]')
      .forEach(initNppSlider);
  }

  function syncActiveSlideOnResize() {
    document
      .querySelectorAll('[data-fcpdp-section] [data-npp-a-slider]')
      .forEach(function (slider) {
        var track = slider.querySelector('[data-npp-a-slider-track]');
        var slides = slider.querySelectorAll('[data-npp-a-slider-slide]');
        var dots = slider.querySelectorAll('[data-npp-a-slider-dot]');
        var prevBtn = slider.querySelector('[data-npp-prev]');
        var nextBtn = slider.querySelector('[data-npp-next]');

        if (!track || !slides.length) {
          return;
        }

        var index = getActiveIndex(track, slider);
        var stride = getSlideStride(track, slider);

        track.scrollLeft = stride * index;
        updateNavState(slider, track, slides, dots, prevBtn, nextBtn, index);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionPdp);
  } else {
    initFeaturedCollectionPdp();
  }

  document.addEventListener('shopify:section:load', initFeaturedCollectionPdp);

  window.addEventListener('resize', function () {
    window.setTimeout(syncActiveSlideOnResize, 150);
  });
})();

